export default __webpack_public_path__ + "static/media/algorand_logo.6fadc498.png";